<template lang="pug">
menu-item(:label=`$t('fits_images')`, v-model="module.showManager", keybind="shift+I")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { FitsImageModule } from "@/modules/FitsImageModule";

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: FitsImageModule
}
</script>

<i18n>
en:
  fits_images: FITS Image
ja:
  fits_images: FITS画像

</i18n>